import httpClient from 'shared/lib/httpClient';

export const getBukuTarifLogDetail = (id, signal) =>
  httpClient
    .get(`/super-admin/tariff-books/${id}`, { signal })
    .then((res) => res.data);
